// extracted by mini-css-extract-plugin
export var cardSelected = "_dv-2";
export var image = "_dv-1";
export var table = "_dv-0";